import { FC } from 'react'
import cn from 'classnames'
import styles from './SingleValue.module.scss'

interface SingleValueProps {
  className?: string
  value: string
}
export const SingleValue: FC<SingleValueProps> = ({ className, value }) => {
  return <div className={cn(styles.container, className)}>{value}</div>
}
